import { REGISTER_ROUTE } from '../../../config';
import { axios } from '../../../config/connection/axios';

import { RegisterResponse } from '../types';

export type RegisterCredentialsDTO = {
  email: string;
  password: string;
  name: string;
};

export const registerWithEmailAndPassword = (
  data: RegisterCredentialsDTO
): Promise<RegisterResponse> => {
  return axios.post(REGISTER_ROUTE, data);
};

/** Confirma a conta pelo código do e-mail de cadastro (a mesma rota que o link antigo abria direto). */
export const confirmarCadastro = (token: string): Promise<string> =>
  axios.get('/user', { params: { recoveryToken: token } });